<template>
  <section>
    <div class="container is-grid">
      <div class="is-col-12-md">
        <h1>
          Order<br class="show-br-mobile"/> History </h1>
        <p class="header-paragraph">
          Here&rsquo;s every order you’ve placed on your Sun Hero journey thus far. </p>
      </div>
      <div v-if="showNoOrders==0">
        <p><img src="@/assets/images/global/loader.gif" alt=""/></p>
      </div>
      <div v-if="showNoOrders==1" class="no-orders-msg">
        <p><strong>You have no orders.</strong></p>
      </div>
      <div class="is-col-12-md" v-if="showNoOrders==2">
        <ul id="order-list">
          <li>
            <div class="date-row header">
              <p><strong>Date</strong></p>
            </div>
            <div class="name-row header">
              <p><strong>Description</strong></p>
            </div>
            <div class="status-row header">
              <p><strong>Status</strong></p>
            </div>
          </li>
          <li v-for="order in orders">
            <div class="date-row">
              <p>{{ order.created_at | moment('MM/DD/YY') }}</p>
            </div>
            <div class="name-row" @click="toggleDetail(order.id)">
              <span class="link-name">{{ order.program_name }}</span>
              <div class="description" v-if="isDetailShown(order.id)">
                <p v-show="order.presentation_date">
                  <strong>Presentation Date:</strong> {{ order.presentation_date }} </p>
                <p v-show="order.status">
                  <strong>Status:</strong><br class="show-br-mobile"/> {{ order.status }} </p>
                <p v-show="order.ccg_tracking_number">
                  <strong>Tracking number:</strong><br class="show-br-mobile"/> {{ order.ccg_tracking_number }} </p>
                <p v-show="order.date_shipped">
                  <strong>Date Shipped:</strong><br class="show-br-mobile"/> {{ order.ccg_date_shipped }} </p>
                <p v-show="order.first_name">
                  <strong>Shipped To:</strong><br class="show-br-mobile"/> {{ order.first_name }} {{ order.last_name }}
                </p>
                <p v-show="order.address_first">
                  <strong>Address: </strong><br class="show-br-mobile"/> <span class="address-detail">
                    {{ order.address_first }}
                    <span v-show="order.address_second"><br/>{{ order.address_second }}</span>
                    <br/>{{ order.address_city }}, {{ order.address_state }}
                    {{ order.address_zip }}
                  </span>
                </p>
              </div>
            </div>
            <div class="status-row">{{ order.status }}</div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import SignUpThanksPage from './SignUpThanksPage'

export default {
  components: { SignUpThanksPage },
  data: () => {
    return {
      showNoOrders: 0,
      orders: [],
      errors: [],
      showDetail: [],
    }
  },
  created () {
    this.getFormData()
  },
  methods: {
    getFormData () {
      const _this = this
      _this.axios.get(_this.$apiUrl + 'v1/order').then(function (response) {
        if (response.data.errors.length === 0) {
          _this.orders = response.data.orders
          if (response.data.orders.length > 0)
            _this.showNoOrders = 2
          else
            _this.showNoOrders = 1
        }
      }).catch(function (error) {
        _this.output = error
      })
    },
    toggleDetail (id) {
      if (!this.showDetail.includes(id)) {
        this.showDetail.push(id)
      } else {
        this.showDetail.splice(this.showDetail.indexOf(id), 1)
      }
    },
    isDetailShown (id) {
      return this.showDetail.indexOf(id) > -1
    },
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.container {
  display: flex;
  flex-flow: column wrap;
  // padding-left: 2%;
  @media screen and (max-width: 1000px) {
    padding-left: 20px;
  }

  h1 {
    font-size: 60px;
    text-transform: uppercase;
    text-align: left;
    margin-top: 65px;
    @media screen and (max-width: 1000px) {
      margin-top: 1.11em;
      font-size: 45px;
      text-align: center;
      margin-right: 0;
      width: 100%;
    }

    // @media screen and (max-width: ~"@{mq-xs-bp}") {
    //   width: 100%;
    // }
  }

  h2 {
    @media screen and (max-width: 1000px) {
      font-size: 24px;
    }
  }

  .header-paragraph {
    @media screen and (max-width: 1000px) {
      width: 95%;
      margin-right: auto;
      font-size: 1.8em;
    }

    @media screen and (max-width: ~"@{mq-xs-bp}") {
      width: 100%;
      margin-left: 0;
      padding-right: 30px;
    }
  }
}

span.address-detail {
  display: block;
  // padding-left: 20px;
  padding-bottom: 20px;
  margin-bottom: 10px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding-left: 0;
  }
}

#order-list {
  margin-left: 0;

  li {
    display: flex;
    list-style-type: none;
    margin-top: 0;
    border-bottom: 1px solid @color-border-lt-gray;
    // @media screen and (max-width: 1000px) {
    //   display: block;
    // }
    .header {
      p {
        font-family: @open-sans-font;
        font-size: 20px;
      }
    }

    .date-row {
      width: 30%;
      border-right: 1px solid @color-border-lt-gray;
      padding-bottom: 20px;
      padding-top: 10px;
    }

    .name-row {
      width: 70%;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        width: 55%;
      }
      padding-top: 10px;

      .link-name {
        font-size: 16px;
        cursor: pointer;
        color: @color-dk-orange;
        text-decoration: underline;
        margin-left: 20px;
        @media screen and (max-width: ~"@{mq-md-bp}em") {
          margin-left: 0;
          font-size: 15px;
        }
      }

      .description {
        font-size: 14px;

        span {
          padding-left: 0;
        }
      }

      p {
        padding-left: 20px;
      }
    }

    .status-row {
      width: 30%;
      border-left: 1px solid @color-border-lt-gray;
      padding-left: 20px;
      padding-top: 10px;
    }

    &:last-of-type {
      border-bottom: none !important;
    }
  }
}

.no-border-mobile {
  @media screen and (max-width: 1200px) {
    border: none !important;
  }
}

.no-orders-msg {
  p {
    strong {
      font-size: 23px;
    }
  }
}
</style>
